<script lang="ts">
    import type {Thread} from 'src/features/threads/types';
    import {createEventDispatcher} from 'svelte';
    import KpGenericTopbar from 'shared/components/kp-generic-topbar/KpGenericTopbar.svelte';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';

    export let thread: Thread;

    const dispatch = createEventDispatcher<{'close': void}>();
</script>

<KpGenericTopbar horizontalPadding="16px">
    <KpIconButton icon="arrow-small-left" noBackground on:click={() => dispatch('close')}/>
    <span class="thread-name">{thread.name}</span>

    <KpButtonStyleAnchor buttonSize="xs" target="_blank" href="/#!/threads/{thread.id}">
        Zobrazit na novém okně
    </KpButtonStyleAnchor>
</KpGenericTopbar>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .thread-name {
        font-weight: 500;
        font-size: @font-size-xl;
        flex: 1;
    }
</style>